import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-external-module',
  templateUrl: './external-module.component.html',
  styleUrls: ['./external-module.component.scss']
})
export class ExternalModuleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
